<template>
  <v-app class="bg-lightBlue">
    <v-container>
      <v-row class="justify-start">
        <v-col class="col-12 col-md-8 col-lg-6 col-xl-5">
          <div class="d-inline-flex primary--text">
            <h2 class="text-md-left primary--text">
              {{ $t('dateBank.title') }}
            </h2>
          </div>
        </v-col>
      </v-row>
      <v-form v-model="isFormValid">
        <v-row class="justify-center">
          <v-col class="col-12 col-md-9">
            <v-row class="justify-center">
              <v-col class="col-12 col-md-9">
                <div class="bg-secondaryGray br-8 pa-5">
                  <h2 class="primary--text text-center f-1">Dados Bancários</h2>
                </div>
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col class="col-12 col-md-9 pb-0">
                <v-select :items="companyType" label="Tipo de conta" v-model="companyOrIndividual" :rules="rules" required
                  solo flat background-color="#F7F7F7" @change="resetForm"></v-select>
              </v-col>
            </v-row>
            <v-row class="justify-center" v-if="companyOrIndividual">
              <v-col class="col-12 col-md-9 pt-0">
                <v-col class="col-12" v-if="companyOrIndividual === 'company'">
                  <v-text-field filled label="Digite a Razão Social da empresa"
                    :required="companyOrIndividual === 'company'" class="input-banco" hide-details="auto" :rules="rules"
                    v-model="company.name"></v-text-field>
                  <v-text-field filled label="CNPJ" :required="companyOrIndividual === 'company'" class="input-banco"
                    hide-details="auto" :rules="rules" v-mask="'##.###.###/####-##'"
                    v-model="company.cnpj"></v-text-field>
                  <br />
                  Endereço Comercial Registrado
                  <br />
                  <v-text-field filled label="Digite o código Postal" v-mask="'#####-###'"
                    :required="companyOrIndividual === 'company'" class="input-banco" hide-details="auto" :rules="rules"
                    v-model="company.zipCode"></v-text-field>
                  <v-text-field filled label="Endereço" :required="companyOrIndividual === 'company'" class="input-banco"
                    hide-details="auto" :rules="rules" v-model="company.address"></v-text-field>
                  <v-text-field filled label="Cidade" :required="companyOrIndividual === 'company'" class="input-banco"
                    hide-details="auto" :rules="rules" v-model="company.city"></v-text-field>
                  <v-text-field filled label="Sigla do Estado" :required="companyOrIndividual === 'company'"
                    class="input-banco" hide-details="auto" :rules="rules" v-model="company.state"></v-text-field>
                  <v-text-field filled label="Digite aqui seu Telefone Comercial"
                    :required="companyOrIndividual === 'company'" v-mask="'## ##### ####'" class="input-banco"
                    hide-details="auto" :rules="rules" v-model="company.phone"></v-text-field>
                  <v-select :items="companyDocumentType" label="Tipo de Contrato" v-model="company.contractType"
                    :rules="rules" :required="companyOrIndividual === 'company'" solo flat background-color="#F7F7F7"
                    @change="resetForm"></v-select>
                  <v-file-input v-if="company.contractType" solo flat label="Documento de comprovação comercial"
                    :prepend-icon="null" :required="companyOrIndividual === 'company'" background-color="#fff"
                    height="100" class="input-banco input-banco-nexo" hide-details="auto" :rules="rules"
                    v-model="company.document">
                    <template v-slot:label>
                      <div>
                        <p class="ma-0 labelGray--text">
                          <v-icon color="labelGray" class="mb-1" medium>
                            description
                          </v-icon>
                          <span class="text-decoration-underline">
                            Clique aqui para anexar ({{ company.contractType }})
                          </span>
                        </p>
                        <p class="ma-0 ml-1 text-body-2 font-italic" color="primary">
                          Ex: Anexe o documento de {{ company.contractType }} aqui.
                        </p>
                      </div>
                    </template>
                  </v-file-input>
                  <br />
                </v-col>
                <!-- ------------------------------------------------------------------------------------ -->
                Dados Pessoais
                <br />
                <v-select :items="personDocumentType" label="Tipo de Documento Pessoal" v-model="personal.documentType"
                  :rules="rules" required solo flat background-color="#F7F7F7" @change="resetForm"></v-select>
                <v-file-input v-if="personal.documentType" solo flat label="Documento de comprovação comercial"
                  :prepend-icon="null" required background-color="#fff" height="100" class="input-banco input-banco-nexo"
                  hide-details="auto" :rules="rules" v-model="personal.document">
                  <template v-slot:label>
                    <div>
                      <p class="ma-0 labelGray--text">
                        <v-icon color="labelGray" class="mb-1" medium>
                          description
                        </v-icon>
                        <span class="text-decoration-underline">
                          Documento Pessoal ({{ personal.documentType }})
                        </span>
                      </p>
                      <p class="ma-0 ml-1 text-body-2 font-italic" color="primary">
                        Adicione seus Documentos Pessoais Aqui
                      </p>
                    </div>
                  </template>
                </v-file-input>
                <v-text-field filled label="Digite aqui seu telefone" required v-mask="'## ##### ####'"
                  class="input-banco" hide-details="auto" :rules="rules" v-model="personal.phone"></v-text-field>

                <v-text-field filled label="Digite nome do Responsável" required class="input-banco" hide-details="auto"
                  :rules="rules" v-model="personal.name"></v-text-field>

                <v-text-field filled label="CPF do Responsável" v-mask="'###.###.###-##'" required class="input-banco"
                  hide-details="auto" :rules="rules" v-model="personal.cpf"></v-text-field>
                <v-text-field filled label="CEP do Responsável" v-mask="'#####-###'" required class="input-banco"
                  hide-details="auto" :rules="rules" v-model="personal.zipCode"></v-text-field>
                <v-text-field filled label="Endereço do Responsável" required class="input-banco" hide-details="auto"
                  :rules="rules" v-model="personal.address"></v-text-field>
                <v-row class="justify-center pa-3 align-center">
                  <v-col cols="11" class="pa-0">
                    <v-select :items="exposed_policy" label="Exposição politica ?" v-model="personal.isExposedPolicy"
                      :rules="rules" item-value="value" required flat solo filled hide-details="auto"
                      background-color="#F7F7F7" />
                  </v-col>
                  <v-col cols="1" class="pa-0 justify-center align-center d-flex">
                    <a href="https://support.stripe.com/questions/defining-political-exposure-in-brazil"
                      class="d-flex align-center" target="_blank" rel="noopener noreferrer">
                      <img src="../../../assets/info-red.svg" width="20" height="20" />
                    </a>
                  </v-col>
                </v-row>
                <v-file-input solo flat label="Comprovante de Endereço do titular" :prepend-icon="null" required
                  background-color="#fff" height="100" class="input-banco input-banco-nexo" hide-details="auto"
                  :rules="rules" v-model="personal.comprovanteEndereco">
                  <template v-slot:label>
                    <div>
                      <p class="ma-0 labelGray--text">
                        <v-icon color="labelGray" class="mb-1" medium>
                          description
                        </v-icon>
                        <span class="text-decoration-underline">
                          Comprovante de endereço do títular
                        </span>
                      </p>
                      <!-- <p class="ma-0 ml-1 text-body-2 font-italic" color="primary">
                        Ex: passaporte, documento de identidade<br />
                        oficial,conta de água, luz ou telefone.
                      </p> -->
                    </div>
                  </template>
                </v-file-input>
                <br />
                Dados Bancários
                <br />
                <v-select :items="banks" label="Banco" v-model="bank.selectedBank" item-value="value" :rules="rules"
                  required flat filled hide-details="auto"></v-select>

                <v-text-field filled label="Número da agência (sem o dígito)" required class="input-banco"
                  hide-details="auto" :rules="rules" v-model="bank.agencyNumber"></v-text-field>
                <v-text-field filled label="Número da conta" required class="input-banco" hide-details="auto"
                  :rules="rules" v-model="bank.accountNumber"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
      <div class="d-flex flex-column align-center justify-center mt-5">
        <v-btn large color="secondary" :disabled="!isFormValid || isLoading" :loading="isLoading"
          @click="createBankAccountSubmit" style="align-self: center">Registrar</v-btn>
        <v-btn class="mt-3" text style="align-self: center" @click="$router.replace('/psicologo/dashboard')">Cancelar</v-btn>
      </div>
    </v-container>
  </v-app>
</template>

<script>
import { mask } from 'vue-the-mask';
import axios from 'axios';
import {
  createBankAccount,
  getProfile,
  uploadStripeDocument,
} from '../../../services/psychologists';
import i18n from '../../../plugins/i18n';
import getLanguage from '../../../utils/getLanguage';
import { padWithZeroes } from '../../../utils';

export default {
  data() {
    return {
      companyOrIndividual: '',
      isFormValid: false,
      companyType: [
        {
          text: 'Pessoa Jurídica',
          value: 'company',
        },
        {
          text: 'Pessoa Física',
          value: 'individual',
        },
      ],
      companyDocumentType: [
        {
          text: 'Contrato Social',
          value: 'Contrato Social',
        },
        {
          text: 'Estudo Social',
          value: 'Estudo Social',
        },
        {
          text: 'CCMEI',
          value: 'CCMEI',
        },
        {
          text: 'Requerimento de Empresário individual',
          value: 'Requerimento de Empresário individual',
        },
        {
          text: 'Empresa de Pequeno Porte',
          value: 'Empresa de Pequeno Porte',
        },
        {
          text: 'EIRELI',
          value: 'EIRELI',
        },
        {
          text: 'Outros',
          value: 'Outros',
        },
      ],
      personDocumentType: [
        {
          text: 'CHN',
          value: 'cnh',
        },
        {
          text: 'RG',
          value: 'rg',
        },
        {
          text: 'Passaporte',
          value: 'passaport',
        },
      ],
      exposed_policy: [
        {
          text: 'Sim',
          value: 'existing',
        },
        {
          text: 'Não',
          value: 'none',
        },
      ],
      banks: [],
      nome: '',
      representanteEmpresa: '',
      codigoPostal: '',
      telefone: '',
      codigoIban: '',
      cnpjResponsavel: '',
      endereco: '',
      comprovanteEndereco: null,
      comprovanteIdentidade: null,
      isLoading: false,
      rules: [(v) => !!v || 'Esse campo é obrigatório'],
      stripeVariables: null,
      lang: '',
      bankNumber: '',
      agencyNumber: '',
      numberMask: '',
      codigoPostalMask: '',
      personal: {
      },
      company: {
        address: '',
        city: '',
        state: '',
      },
      bank: {
        selectedBank: '',
        agencyNumber: '',
        accountNumber: '',
      }
    };
  },
  directives: {
    mask,
  },
  created() {
    this.checkUserbankAccount();
    this.lang = getLanguage(window.location.href);
    this.numberMask = '+## (##) # ########';
    this.codigoPostalMask = '#####-###';
    this.getBankArray();
  },
  mounted() {
    this.stripeVariables = this.lang === 'pt-BR' ? process.env.VUE_APP_STRIPE_KEY_BR : process.env.VUE_APP_STRIPE_KEY;
  },
  methods: {
    async checkUserbankAccount() {
      const localUser = JSON.parse(localStorage.getItem('user-data'));
      const user = await getProfile(localUser.id);
      if (user.digital_account != null) {
        this.$router.replace('/psicologo/');
        this.$showSnackbar(
          'Você já possui uma conta bancária e não pode modificar.',
        );
      }
    },
    async getBankArray() {
      const { data } = await axios.get('https://brasilapi.com.br/api/banks/v1');
      let bankList = data
      if (!process.env.VUE_APP_BASE_URL_AXIOS.includes('ondivan.heroku')) {
        const testStripeBank = {
          "ispb": "00000000",
          "name": "Banco teste STRIPE",
          "code": 110,
          "fullName": "Banco teste STRIPE."
        }
        bankList = [testStripeBank, ...bankList]
      }
      this.banks = bankList
        .filter((bank) => bank.code)
        .sort((a, b) => {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          return 0;
        })
        .map((bank) => ({
          text: bank.name,
          value: bank.code,
        }));
    },
    async createBankAccountSubmit() {
      console.log('personal:', this.personal)
      console.log('company:', this.company)
      console.log('bank:', this.bank)
      this.isLoading = true;
      const promiseAllSelectedResponse = await Promise.allSettled([
        uploadStripeDocument(this.personal.comprovanteEndereco, this.stripeVariables, 'additional_verification'),
        uploadStripeDocument(this.company.document, this.stripeVariables, 'identity_document'),
        uploadStripeDocument(this.personal.document, this.stripeVariables, 'identity_document')
      ])
      console.log("promiseAllSelectedResponse", promiseAllSelectedResponse)
      const [
        retornoStripeFileEndereco,
        retornoStripeFileCompanyDocument,
        retornoStripeFileIdentidade,
      ] = promiseAllSelectedResponse;
      console.log("arquivos", retornoStripeFileEndereco, retornoStripeFileCompanyDocument, retornoStripeFileIdentidade)
      const routingNumber = `${padWithZeroes(this.bank.selectedBank, 3)}-${this.bank.agencyNumber}`;

      const dataFormCompany = {
        political_exposure: this.isExposedPolicy,
        routing_number: routingNumber,
        bank: {
          ...this.bank,
          routing_number: routingNumber
        },
        personal: {
          ...this.personal,
          phone: `+55${this.personal.phone.replace(/\D/g, "")}`,
          cpf: this.personal.cpf.replace(/\D/g, ""),
          zipCode: this.personal.zipCode.replace(/\D/g, ""),
        },
        company: this.companyOrIndividual === 'company' ? {
          ...this.company,
          phone: `+55${this.company.phone.replace(/\D/g, "")}`,
          cnpj: this.company.cnpj.replace(/\D/g, ""),
          zipCode: this.company.zipCode.replace(/\D/g, ""),
        } : {},
        companyOrIndividual: this.companyOrIndividual,
        type_account: this.companyOrIndividual,
        company_representative: this.personal.name,
        iban_code: this.bank.accountNumber,
        vat_number: this.personal.cpf,
        name: this.personal.name,
        phone: `+55${this.personal.phone.replace(/\D/g, "")}`,
        street: this.personal.address,
        zip_code: this.personal.zipCode.replace(/\D/g, ""),
        cpf: this.personal.cpf.replace(/\D/g, ""),
        political_exposure: this.personal.isExposedPolicy,
        file_additional_verification: retornoStripeFileEndereco.value || null,
        file_identity_document: retornoStripeFileIdentidade.value || null,
        company_verification_document: retornoStripeFileCompanyDocument.value || null,
      };
      try {
        await createBankAccount(dataFormCompany);
        this.$showSnackbar('Cadastro bancário realizado com sucesso.');
        this.$router.push('/psicologo/profile');
      } catch (error) {
        this.$showSnackbar(error[0]);
      } finally {
        this.isLoading = false;
      }
    },
    resetForm() {
      this.nome = '';
      this.representanteEmpresa = '';
      this.codigoPostal = '';
      this.telefone = '';
      this.codigoIban = '';
      this.cnpjResponsavel = '';
    },
  },
};
</script>

<style lang="css" scoped>
*>>>.input-banco .v-input__slot {
  height: 60px;
}

*>>>.input-banco .v-label {
  height: auto;
}

*>>>.v-file-input__text {
  height: 70px !important;
  cursor: pointer !important;
}

*>>>.input-banco {
  border-radius: 0;
}

*>>>.input-banco-nexo .v-label {
  overflow: visible !important;
  text-overflow: ellipsis !important;
  top: calc(50% - 34px) !important;
}

*>>>.input-banco-identidade .v-label {
  overflow: visible !important;
  text-overflow: ellipsis !important;
  top: calc(50% - 13px) !important;
}

/* * >>> .input-banco input {
  text-align: center;
} */

/* * >>> .input-banco .v-label {
  max-width: 100%;
  width: 100%;
  text-align: center;
} */

.input-banco:first-of-type {
  border-top: 1px solid #ccc;
}

.input-banco {
  border-bottom: 1px solid #ccc;
}
</style>
